export const isStag = () => {
  return location.href.startsWith('https://stag');
};
